module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page project"
  }, [_c('h2', [_vm._v(_vm._s(_vm.project.name))]), _vm._v(" "), _c('ul', _vm._l((_vm.project.content), function(content) {
    return _c('li', [(_vm.isVimeo(content)) ? _c('vimeo-embed', {
      key: content,
      attrs: {
        "url": content
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isImage(content)) ? _c('img', {
      key: content,
      attrs: {
        "src": _vm.imagePath(content)
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.isImage(content) && !_vm.isVimeo(content)) ? _c('p', {
      key: content
    }, [_vm._v("\n        " + _vm._s(content) + "\n      ")]) : _vm._e()], 1)
  }), 0), _vm._v(" "), _c('more-projects', {
    attrs: {
      "project": _vm.project
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74fb6a47"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Project.vue
// module id = 117
// module chunks = 0